import { cva } from 'class-variance-authority';

export const spinnerVariants = cva('animate-spin shrink-0', {
  variants: {
    size: {
      xs: 'size-3',
      sm: 'size-4',
      md: 'size-6',
      lg: 'size-8',
      xl: 'size-10',
    },
    tone: {
      current: 'text-current',
      brand: 'text-brand-blue',
      muted: 'text-muted-foreground',
    },
  },
  defaultVariants: {
    size: 'sm',
    tone: 'current',
  },
});
